import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#151515",
  "stroke-width": "1.5",
  d: "M16.177 6.677a4.177 4.177 0 1 0-8.355 0"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#151515",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M17.184 6.677H6.818a2 2 0 0 0-1.983 1.748c-.384 3.043-.94 7.47-1.169 9.353-.278 2.291 2.2 3.103 3.473 3.222h10.073c2.779 0 3.242-2.148 3.126-3.222l-1.17-9.349a2 2 0 0 0-1.984-1.752"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F56A00",
  stroke: "#151515",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M11.731 10.045a.3.3 0 0 1 .538 0l.984 1.993a.3.3 0 0 0 .226.164l2.2.32a.3.3 0 0 1 .165.512l-1.591 1.551a.3.3 0 0 0-.087.266l.376 2.19a.3.3 0 0 1-.435.317l-1.967-1.035a.3.3 0 0 0-.28 0l-1.967 1.035a.3.3 0 0 1-.435-.317l.375-2.19a.3.3 0 0 0-.086-.266l-1.591-1.551a.3.3 0 0 1 .166-.512l2.2-.32a.3.3 0 0 0 .225-.164z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }